export const data = [
  {
    index_id: 15820,
    run_date: "2018-06-11",
    location: "M",
    name: "Robin Bridges",
    target_weight: 115.5,
    actual_ufr: 9.2,
    lowest_bp_systolic: 59,
    pre_bp_systolic: 126,
    post_bp_systolic: 161,
    post_wt_kg: 114.0,
    avg_post_wt_kg: 114.4,
    diff_postwt_calctargetwt: -1.0,
    change_in_pw: 0.0,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 70.0,
    avg_3day_post_sys: 148.0,
    avg_3day_post_sys_bin: ">140",
    avg_3day_pre_sys: 137.0,
    avg_3day_pre_sys_bin: "130_149",
    idwg_percent_ehr: 0.036,
    inter_dia_wt_gain: 4.2,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 4,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 116.15,
    step1_proposed_tw_reco: "Reduce TW",
    step2_proposed_tw_reco: "Reduce TW & Increase UF Time",
    ufr_to_reach_tw: 7.1,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.21,
    num_runs_pw_tw_less_1_minus: 3,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 6.8,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 116.0
  },
  {
    index_id: 15820,
    run_date: "2018-06-11",
    location: "M",
    name: "Robin Bridges",
    target_weight: 117.0,
    actual_ufr: 9.2,
    lowest_bp_systolic: 59,
    pre_bp_systolic: 126,
    post_bp_systolic: 161,
    post_wt_kg: 116.0,
    avg_post_wt_kg: 116.3,
    diff_postwt_calctargetwt: -1.0,
    change_in_pw: 0.0,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 84.0,
    avg_3day_post_sys: 128.0,
    avg_3day_post_sys_bin: ">120_<=140",
    avg_3day_pre_sys: 137.0,
    avg_3day_pre_sys_bin: "130_149",
    idwg_percent_ehr: 0.036,
    inter_dia_wt_gain: 4.2,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 4,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 116.15,
    step1_proposed_tw_reco: "Reduce TW",
    step2_proposed_tw_reco: "Reduce TW & Increase UF Time",
    ufr_to_reach_tw: 7.1,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.14,
    num_runs_pw_tw_less_1_minus: 2,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 7.0,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 116.0
  },
  {
    index_id: 12794,
    run_date: "2018-04-11",
    location: "M",
    name: "Robin Bridges",
    target_weight: 115.0,
    actual_ufr: 8.7,
    lowest_bp_systolic: 53,
    pre_bp_systolic: 149,
    post_bp_systolic: 160,
    post_wt_kg: 114.9,
    avg_post_wt_kg: 114.8,
    diff_postwt_calctargetwt: -0.09999999999999432,
    change_in_pw: 0.6999999999999886,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 74.0,
    avg_3day_post_sys: 146.0,
    avg_3day_post_sys_bin: ">140",
    avg_3day_pre_sys: 125.0,
    avg_3day_pre_sys_bin: "110_129",
    idwg_percent_ehr: 0.029,
    inter_dia_wt_gain: 3.3,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 3,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 114.85,
    step1_proposed_tw_reco: "No Change TW",
    step2_proposed_tw_reco: "Increase UF Time",
    ufr_to_reach_tw: 8.5,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.07,
    num_runs_pw_tw_less_1_minus: 1,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 6.5,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 114.9
  },
  {
    index_id: 12795,
    run_date: "2018-04-09",
    location: "M",
    name: "Robin Bridges",
    target_weight: 115.0,
    actual_ufr: 5.2,
    lowest_bp_systolic: 74,
    pre_bp_systolic: 117,
    post_bp_systolic: 151,
    post_wt_kg: 115.6,
    avg_post_wt_kg: 114.7,
    diff_postwt_calctargetwt: 0.5999999999999943,
    change_in_pw: -0.8999999999999915,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 95.0,
    avg_3day_post_sys: 140.0,
    avg_3day_post_sys_bin: ">120_<=140",
    avg_3day_pre_sys: 118.0,
    avg_3day_pre_sys_bin: "110_129",
    idwg_percent_ehr: 0.032,
    inter_dia_wt_gain: 3.7,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "Yes",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "No",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 2,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 115.15,
    step1_proposed_tw_reco: "No Change TW",
    step2_proposed_tw_reco: "No Change",
    ufr_to_reach_tw: 6.3,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.14,
    num_runs_pw_tw_less_1_minus: 2,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 6.2,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.7,
    adjusted_post_wt_kg: 115.6
  },
  {
    index_id: 14224,
    run_date: "2018-05-07",
    location: "M",
    name: "Robin Bridges",
    target_weight: 115.0,
    actual_ufr: 10.0,
    lowest_bp_systolic: 57,
    pre_bp_systolic: 165,
    post_bp_systolic: 135,
    post_wt_kg: 115.0,
    avg_post_wt_kg: 114.9,
    diff_postwt_calctargetwt: 0.0,
    change_in_pw: -0.09999999999999432,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 65.0,
    avg_3day_post_sys: 145.0,
    avg_3day_post_sys_bin: ">140",
    avg_3day_pre_sys: 139.0,
    avg_3day_pre_sys_bin: "130_149",
    idwg_percent_ehr: 0.041,
    inter_dia_wt_gain: 4.7,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 5,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 114.9,
    step1_proposed_tw_reco: "No Change TW",
    step2_proposed_tw_reco: "Increase UF Time",
    ufr_to_reach_tw: 10.0,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.0,
    num_runs_pw_tw_less_1_minus: 0,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 9.5,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 115.0
  },
  {
    index_id: 16514,
    run_date: "2018-07-06",
    location: "M",
    name: "Robin Bridges",
    target_weight: 116.5,
    actual_ufr: 7.7,
    lowest_bp_systolic: 52,
    pre_bp_systolic: 131,
    post_bp_systolic: 127,
    post_wt_kg: 116.9,
    avg_post_wt_kg: 116.5,
    diff_postwt_calctargetwt: 0.4,
    change_in_pw: -0.2,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 51.0,
    avg_3day_post_sys: 143.0,
    avg_3day_post_sys_bin: ">140",
    avg_3day_pre_sys: 106.0,
    avg_3day_pre_sys_bin: "100_109",
    idwg_percent_ehr: 0.033,
    inter_dia_wt_gain: 3.8,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 5,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 116.55,
    step1_proposed_tw_reco: "No Change TW",
    step2_proposed_tw_reco: "Increase UF Time",
    ufr_to_reach_tw: 8.6,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.43,
    num_runs_pw_tw_less_1_minus: 6,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 8.1,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 116.9
  },
  {
    index_id: 15413,
    run_date: "2018-06-06",
    location: "M",
    name: "Robin Bridges",
    target_weight: 117.0,
    actual_ufr: 2.4,
    lowest_bp_systolic: 93,
    pre_bp_systolic: 159,
    post_bp_systolic: 124,
    post_wt_kg: 116.0,
    avg_post_wt_kg: 116.1,
    diff_postwt_calctargetwt: -1.0,
    change_in_pw: 1.0,
    change_in_pw_impact: "Large",
    ave_low_bp_3rx: 84.0,
    avg_3day_post_sys: 106.0,
    avg_3day_post_sys_bin: ">100_<=110",
    avg_3day_pre_sys: 125.0,
    avg_3day_pre_sys_bin: "110_129",
    idwg_percent_ehr: 0.01,
    inter_dia_wt_gain: 1.2,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 4,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 116.07,
    step1_proposed_tw_reco: "Reduce TW",
    step2_proposed_tw_reco: "Reduce TW & Increase UF Time",
    ufr_to_reach_tw: 0.2,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.07,
    num_runs_pw_tw_less_1_minus: 1,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 6.4,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 116.0
  },
  {
    index_id: 16515,
    run_date: "2018-07-04",
    location: "M",
    name: "Robin Bridges",
    target_weight: 115.5,
    actual_ufr: 7.3,
    lowest_bp_systolic: 52,
    pre_bp_systolic: 116,
    post_bp_systolic: 162,
    post_wt_kg: 112.7,
    avg_post_wt_kg: 112.4,
    diff_postwt_calctargetwt: 0.2,
    change_in_pw: 0.4,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 59.0,
    avg_3day_post_sys: 141.0,
    avg_3day_post_sys_bin: ">140",
    avg_3day_pre_sys: 91.0,
    avg_3day_pre_sys_bin: "<100",
    idwg_percent_ehr: 0.026,
    inter_dia_wt_gain: 3.0,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 4,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 116.4,
    step1_proposed_tw_reco: "No Change TW",
    step2_proposed_tw_reco: "Increase TW & UF Time",
    ufr_to_reach_tw: 7.7,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.43,
    num_runs_pw_tw_less_1_minus: 6,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 8.2,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 116.7
  },
  {
    index_id: 13840,
    run_date: "2018-05-04",
    location: "M",
    name: "Robin Bridges",
    target_weight: 115.0,
    actual_ufr: 5.4,
    lowest_bp_systolic: 72,
    pre_bp_systolic: 104,
    post_bp_systolic: 140,
    post_wt_kg: 114.9,
    avg_post_wt_kg: 114.8,
    diff_postwt_calctargetwt: -0.09999999999999432,
    change_in_pw: -0.4000000000000057,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 75.0,
    avg_3day_post_sys: 138.0,
    avg_3day_post_sys_bin: ">120_<=140",
    avg_3day_pre_sys: 124.0,
    avg_3day_pre_sys_bin: "110_129",
    idwg_percent_ehr: 0.025,
    inter_dia_wt_gain: 2.9,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 5,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 114.8,
    step1_proposed_tw_reco: "No Change TW",
    step2_proposed_tw_reco: "Increase UF Time",
    ufr_to_reach_tw: 5.2,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.0,
    num_runs_pw_tw_less_1_minus: 0,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 8.7,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 114.9
  },
  {
    index_id: 16516,
    run_date: "2018-07-02",
    location: "M",
    name: "Robin Bridges",
    target_weight: 116.5,
    actual_ufr: 7.7,
    lowest_bp_systolic: 50,
    pre_bp_systolic: 73,
    post_bp_systolic: 140,
    post_wt_kg: 117.1,
    avg_post_wt_kg: 116.2,
    diff_postwt_calctargetwt: 0.6,
    change_in_pw: -1.1,
    change_in_pw_impact: "Large",
    ave_low_bp_3rx: 65.0,
    avg_3day_post_sys: 117.0,
    avg_3day_post_sys_bin: ">110_<=120",
    avg_3day_pre_sys: 102.0,
    avg_3day_pre_sys_bin: "100_109",
    idwg_percent_ehr: 0.033,
    inter_dia_wt_gain: 3.9,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 3,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 116.3,
    step1_proposed_tw_reco: "No Change TW",
    step2_proposed_tw_reco: "Increase UF Time",
    ufr_to_reach_tw: 9.0,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.43,
    num_runs_pw_tw_less_1_minus: 6,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 7.5,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 117.1
  },
  {
    index_id: 13841,
    run_date: "2018-05-02",
    location: "M",
    name: "Robin Bridges",
    target_weight: 115.0,
    actual_ufr: 9.8,
    lowest_bp_systolic: 67,
    pre_bp_systolic: 149,
    post_bp_systolic: 159,
    post_wt_kg: 114.5,
    avg_post_wt_kg: 114.8,
    diff_postwt_calctargetwt: -0.5,
    change_in_pw: 0.5999999999999943,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 86.0,
    avg_3day_post_sys: 135.0,
    avg_3day_post_sys_bin: ">120_<=140",
    avg_3day_pre_sys: 133.0,
    avg_3day_pre_sys_bin: "130_149",
    idwg_percent_ehr: 0.034,
    inter_dia_wt_gain: 3.9,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 5,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 114.6,
    step1_proposed_tw_reco: "No Change TW",
    step2_proposed_tw_reco: "Increase UF Time",
    ufr_to_reach_tw: 8.7,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.0,
    num_runs_pw_tw_less_1_minus: 0,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 9.0,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 114.5
  },
  {
    index_id: 15185,
    run_date: "2018-06-01",
    location: "M",
    name: "Robin Bridges",
    target_weight: 117.0,
    actual_ufr: 4.3,
    lowest_bp_systolic: 101,
    pre_bp_systolic: 127,
    post_bp_systolic: 101,
    post_wt_kg: 117.0,
    avg_post_wt_kg: 115.8,
    diff_postwt_calctargetwt: 0.0,
    change_in_pw: 0.1,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 71.0,
    avg_3day_post_sys: 114.0,
    avg_3day_post_sys_bin: ">110_<=120",
    avg_3day_pre_sys: 115.0,
    avg_3day_pre_sys_bin: "110_129",
    idwg_percent_ehr: 0.026,
    inter_dia_wt_gain: 3.0,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 5,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 116.4,
    step1_proposed_tw_reco: "Reduce TW",
    step2_proposed_tw_reco: "Reduce TW & Increase UF Time",
    ufr_to_reach_tw: 4.3,
    per_runs_pw_tw_more_1: 0.0,
    num_runs_pw_tw_more_1: 0,
    per_runs_pw_tw_less_1_minus: 0.0,
    num_runs_pw_tw_less_1_minus: 0,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 7.6,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.0,
    adjusted_post_wt_kg: 117.0
  },
  {
    index_id: 11783,
    run_date: "2018-03-21",
    location: "M",
    name: "Robin Bridges",
    target_weight: 115.0,
    actual_ufr: 5.3,
    lowest_bp_systolic: 107,
    pre_bp_systolic: 139,
    post_bp_systolic: 161,
    post_wt_kg: 114.4,
    avg_post_wt_kg: 114.4,
    diff_postwt_calctargetwt: -0.6,
    change_in_pw: 0.7,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 93.0,
    avg_3day_post_sys: 149.0,
    avg_3day_post_sys_bin: ">140",
    avg_3day_pre_sys: 145.0,
    avg_3day_pre_sys_bin: "130_149",
    idwg_percent_ehr: 0.017,
    inter_dia_wt_gain: 1.9,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "Yes",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "No",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 4,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 114.4,
    step1_proposed_tw_reco: "Reduce TW",
    step2_proposed_tw_reco: "Reduce TW",
    ufr_to_reach_tw: 4.0,
    per_runs_pw_tw_more_1: 0.14,
    num_runs_pw_tw_more_1: 2,
    per_runs_pw_tw_less_1_minus: 0.14,
    num_runs_pw_tw_less_1_minus: 2,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 4.4,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.3,
    adjusted_post_wt_kg: 114.4
  },
  {
    index_id: 12122,
    run_date: "2018-03-30",
    location: "M",
    name: "Robin Bridges",
    target_weight: 115.0,
    actual_ufr: 5.1,
    lowest_bp_systolic: 59,
    pre_bp_systolic: 158,
    post_bp_systolic: 136,
    post_wt_kg: 114.6,
    avg_post_wt_kg: 114.5,
    diff_postwt_calctargetwt: -0.4,
    change_in_pw: -0.2,
    change_in_pw_impact: "Small",
    ave_low_bp_3rx: 72.0,
    avg_3day_post_sys: 131.0,
    avg_3day_post_sys_bin: ">120_<=140",
    avg_3day_pre_sys: 129.0,
    avg_3day_pre_sys_bin: "110_129",
    idwg_percent_ehr: 0.023,
    inter_dia_wt_gain: 2.7,
    num_runs_bp_drop_less_50_or_avg_bp_drop_more_90: "No",
    num_runs_bp_drop_more_equal_50_and_avg_bp_drop_less_90: "Yes",
    num_runs_idwg_more_5_per: 0,
    num_runs_lowest_bp_less_90: 3,
    per_runs_idwg_more_5_per: 0.0,
    step1_proposed_tw: 114.5,
    step1_proposed_tw_reco: "No Change TW",
    step2_proposed_tw_reco: "Increase UF Time",
    ufr_to_reach_tw: 4.2,
    per_runs_pw_tw_more_1: 0.14,
    num_runs_pw_tw_more_1: 2,
    per_runs_pw_tw_less_1_minus: 0.21,
    num_runs_pw_tw_less_1_minus: 3,
    Threshold_Pre_BP: "160",
    Threshold_Post_BP: "150",
    Threshold_Low_BP: "90",
    Threshold_UFR: "13",
    avg_ufr_run_6rx: 5.4,
    avg_ufr_run_6rx_high: "No",
    ufr_to_reach_tw_high: "No",
    duration_in_hours: 4.3,
    adjusted_post_wt_kg: 114.6
  }
];
